<!-- <div class="chartCard">
  <div class="chartBox">
    <canvas [id]="chartConfig().chartId" #chartCanvas></canvas>
  </div>
</div> -->

<!-- <div class="border border-2 border-success"> -->
<div class="chart-container">
  <canvas [id]="chartConfig().chartId" #chartCanvas></canvas>
</div>
<!-- </div> -->
